import React from "react";
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeSharpIcon from '@mui/icons-material/HomeSharp';
import LocalOfferSharpIcon from '@mui/icons-material/LocalOfferSharp';
import AccountBalanceWalletSharpIcon from '@mui/icons-material/AccountBalanceWalletSharp';
import BadgeSharpIcon from '@mui/icons-material/BadgeSharp';
import Paper from '@mui/material/Paper';
import { NavLink } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from '../theme/theme'
import { appTheme } from "../theme/colorTheme";
const FooterMenu = (props) => {
  const ref = React.useRef(null);
  React.useEffect(() => { });

  const navLinkStyle = ({ isActive }) => {
    return {
      color: isActive ? appTheme.color12 : appTheme.color6,
    };
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ pb: 7}} ref={ref}>
        <Paper
          sx={{ position: "fixed", bottom: 0, left: 0, right: 0,  maxWidth: "600px", margin: "0 auto"}}
          elevation={3}
        >
          <BottomNavigation showLabels sx={{ backgroundColor: appTheme.color0 }}>
            <BottomNavigationAction
              component={NavLink}
              style={navLinkStyle}
              to="/home"
              label="Home"
              value="Home"
              icon={<HomeSharpIcon />}
            />
            <BottomNavigationAction
              component={NavLink}
              style={navLinkStyle}
              to="/offers"
              label="Offers"
              value="Offers"
              icon={<LocalOfferSharpIcon />}
            />
            <BottomNavigationAction
              component={NavLink}
              style={navLinkStyle}
              to="/passbook"
              label="Passbook"
              value="Passbook"
              icon={<AccountBalanceWalletSharpIcon />}
            />
            <BottomNavigationAction
              component={NavLink}
              style={navLinkStyle}
              to="/ids"
              label="Ids"
              value="Ids"
              icon={<BadgeSharpIcon />}
            />
          </BottomNavigation>
        </Paper>
      </Box>
    </ThemeProvider>

  );
};

export default FooterMenu;
